import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { selectCity } from "../../store/slices/citySlice";

export const useCityId = (): number | undefined => {
  const [searchParams] = useSearchParams();
  const selectedCity = useSelector(selectCity);

  // При пререндере (?__prerender=1) не фильтруем по городу
  if (searchParams.get("__prerender") === "1") {
    return undefined;
  }

  return selectedCity?.id;
};
